export { default } from './PriceSpider';
